export default class Chart {
  constructor({
    type,
    chartOptions = [], // time range, etc.
    dataOptions = null, // could be stats of columns
    queryParams = null,
    usesColumns = false, // does this chart use columns for stat selection
    usesTimeRange = false, // does this chart use a time range for data selection
    multipleSourceSupport = false, // does this chart support multiple data sources
    alertSupport = false, // does this chart support alerts
  }) {
    this.type = type;
    this.chartOptions = chartOptions;
    this.dataOptions = dataOptions;
    this.queryParams = queryParams;
    this.usesColumns = usesColumns;
    this.usesTimeRange = usesTimeRange;
    this.multipleSourceSupport = multipleSourceSupport;
    this.alertSupport = alertSupport;
  }
}
